import { request } from "../@utils";
import { requestFile } from "../@utils";
const prefecture = {
    // 分页查询ERP专区列表
    mallZoneList: async (params) => {
        const res = await request.post("/mallZone/list", { data: params });
        return res;
    },
    // 创建ERP专区
    mallZoneCreate: async (params) => {
        const res = await request.post(`/mallZone/create`, { data: params });
        return res;
    },
    // 删除ERP专区
    mallZoneDelete: async (id) => {
        const res = await request.post(`/mallZone/delete/${id}`);
        return res;
    },
    // 编辑ERP专区
    mallZoneUpdate: async (params) => {
        const res = await request.post("/mallZone/update", { data: params });
        return res;
    },
    // 启用/禁用ERP专区
    mallZoneUpdateStatus: async (params) => {
        const res = await request.post("/mallZone/updateStatus", { data: params });
        return res;
    },
    // 查询ERP专区详情
    mallZoneDetail: async (id) => {
        const res = await request.get(`/mallZone/detail/${id}`);
        return res;
    },
    // 批量添加专区商品
    mallZoneProductBatchAdd: async (params) => {
        const res = await request.post(`/mallZone/mallZoneProduct/batchAdd`, { data: params });
        return res;
    },
    // 批量删除绑定商品
    mallZoneProductBatchDelete: async (params) => {
        const res = await request.post(`/mallZone/mallZoneProduct/batchDelete`, { data: params });
        return res;
    },
    // 单个添加专区商品
    mallZoneProductCreate: async (params) => {
        const res = await request.post(`/mallZone/mallZoneProduct/create`, { data: params });
        return res;
    },
    // 删除绑定商品
    mallZoneProductDelete: async (id) => {
        const res = await request.post(`/mallZone/mallZoneProduct/delete/${id}`);
        return res;
    },
    // 专区商品导入
    mallZoneProductImport: async (params) => {
        const res = await request.post(`/mallZone/mallZoneProduct/import`, { data: params });
        return res;
    },
    // 获取专区商品列表
    mallZoneProductList: async (params) => {
        const res = await request.post(`/mallZone/mallZoneProduct/list`, { data: params });
        return res;
    },
    // 更换单个专区商品
    mallZoneProductUpdate: async (params) => {
        const res = await request.post(`/mallZone/mallZoneProduct/update`, { data: params });
        return res;
    },
    // 置顶单个专区商品
    mallZoneProductUpdateSort: async (params) => {
        const res = await request.post(`/mallZone/mallZoneProduct/updateSort`, { data: params });
        return res;
    },
};
export default prefecture;